module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: ""
  }, [_c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "30px",
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px",
      "color": "#aaaaaa"
    }
  }, [_vm._v("客户ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custId),
      expression: "custId"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30",
      "disabled": "true"
    },
    domProps: {
      "value": (_vm.custId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custId = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "color": "#ff0000",
      "margin-top": "-1px",
      "margin-left": "20px"
    }
  }, [_vm._v("客户名称")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custName),
      expression: "custName"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.custName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "width": "32px",
      "height": "32px",
      "background": "url(../static/images/op_fin.png)",
      "margin-top": "-1px",
      "margin-left": "10px"
    },
    on: {
      "click": _vm.onCustClick
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px",
      "color": "#ff0000"
    }
  }, [_vm._v("销售")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.carSaler),
      expression: "carSaler"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "20"
    },
    domProps: {
      "value": (_vm.carSaler)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.carSaler = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px",
      "color": "#ff0000"
    }
  }, [_vm._v("订单号")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aiCert),
      expression: "aiCert"
    }],
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.aiCert)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.aiCert = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "40px"
    }
  }, [_c('div', {
    staticClass: "Capt DIVNoSelect",
    staticStyle: {
      "flex": "0 0 auto",
      "border": "0",
      "width": "160px",
      "margin-top": "-1px",
      "margin-left": "20px",
      "color": "#ff0000"
    }
  }, [_vm._v("金额(美元,元)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.aiMoney),
      expression: "aiMoney"
    }],
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text",
      "maxlength": "6"
    },
    domProps: {
      "value": (_vm.aiMoney)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.aiMoney = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left",
      "width": "100%",
      "height": "40px",
      "border": "0px solid red",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-left": "50px"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("取消")))]), _vm._v(" "), _c('div', {
    staticClass: "NButton DIVNoSelect",
    staticStyle: {
      "padding-left": "10px",
      "padding-right": "10px",
      "margin-top": "16px",
      "margin-right": "50px",
      "float": "right"
    },
    on: {
      "click": _vm.onOKClick
    }
  }, [_vm._v(_vm._s(_vm.getLangText("确定")))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "SiftPanel",
    staticStyle: {
      "border": "0px solid #bbbbbb",
      "height": "30px",
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "1px",
      "background": "#bbbbbb"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f922501","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/aiphoto/airNew.vue
// module id = 789
// module chunks = 1